import { DTOFileReference } from "../files";
import z from "zod";
//
// Entity
//
export const DTOForgeFigmaNodeState = z.enum([
    "Optimizing",
    "Success",
    "Failed",
]);
export const DTOForgeFigmaNodeConversionVersion = z.enum([
    "V1",
    "V2",
    "V3",
    "V4",
    "V5",
    "V6",
    "V7",
    "V8",
    "V9",
    "V10",
    "V11",
    "V12",
]);
export const ForgeFigmaNodeLatestVersion = DTOForgeFigmaNodeConversionVersion.enum.V12;
export const DTOForgeFigmaNodeOrigin = z.object({
    /**
     * Figma file ID that was passed into the create request as a part of the Figma node URL
     */
    fileId: z.string(),
    fileName: z.string(),
    /**
     * Timestamp of the last edit to the file, can be used for reusing nodes
     * if the file has not changed since
     */
    fileLastEditedAt: z.string(),
    /**
     * Figma node ID that was passed into the create request as a part of the Figma node URL
     */
    nodeId: z.string(),
    nodeName: z.string(),
});
export const DTOForgeFigmaNode = z.object({
    id: z.string().uuid(),
    state: DTOForgeFigmaNodeState,
    /**
     * Describes where the frame is coming from
     */
    origin: DTOForgeFigmaNodeOrigin,
    /**
     * An image of the node rendered by Figma using render image API.
     */
    thumbnail: DTOFileReference,
    /**
     * JSON representation of the Figma node, downloaded from Figma API
     */
    json: DTOFileReference,
    /**
     * HTML representation of the Figma node, converted from JSON
     */
    html: DTOFileReference,
    /**
     * @deprecated - Optimizing phase was removed, this field is no longer available.
     *
     * Code representation of the Figma node. Code gets produced during "Optimizing" phase,
     * it's available when the node reaches "Success" state.
     */
    code: DTOFileReference.optional(),
});
//
// Payloads
//
export const DTOForgeFigmaNodeCreateRequest = z.object({
    /**
     * Workspace ID that will own the node. Figma API keys will be used from this workspace.
     */
    workspaceId: z.string(),
    /**
     * URL that points to a Figma file and a node within the file.
     * Example: https://www.figma.com/design/If4RI8SKtO2azWx8ytfp03/Child-File?node-id=0-1
     *
     * Note that the file must contain `node-id` query param, otherwise the request will be rejected
     */
    figmaNodeUrl: z.string().url(),
});
export const DTOForgeFigmaNodeResponse = z.object({
    figmaNode: DTOForgeFigmaNode,
});
export const DTOForgeFigmaNodeValidateResponse = z.object({
    isValid: z.boolean(),
});
